import React from 'react';
import { ArrayHelpers, Copy, Loading, Modal, SystemText } from '@salesperformanceint/e4shared';
import { apiGet } from 'services';
import { useSelector } from 'react-redux';

export const CompetencyDetails = ({ role, show, close }) => {
    const [loading, setLoading] = React.useState(true);
    const [data, setData] = React.useState([]);
    const user = useSelector(state => state.user.user);

    const showRecommendations = user.companySettings?.development.showRecommends;

    React.useEffect(() => {
        setLoading(false);
        apiGet(`role/competency-framework/${role.id}`, user.guid, response => {
            setData(response);
            setLoading(false);
        });
    }, [role.id, user.guid]);

    return (
        <Modal show={show} close={close} title={SystemText('Admin/Roles/Details/Title', role.name)} footer={null}>
            {loading ? (
                <Loading />
            ) : (
                <div>
                    {data.length === 0 && <div>{SystemText('Admin/Roles/Details/NoResults')}</div>}
                    {data.map((d, i) => {
                        return (
                            <div className="mb10" key={`details-${d.id}`}>
                                {i > 0 && <hr className="mb10" />}
                                <div className="text-sm uppercase">{d.area}</div>
                                <div className="">
                                    <h3 style={{ margin: '5px 0' }}>{d.name}</h3>
                                </div>
                                <div className="text-sm">
                                    <Copy value={d.description} />
                                </div>
                                {showRecommendations && ArrayHelpers.existsAndHasLength(d.positiveIndicators) && (
                                    <div className="mt10">
                                        {d.positiveIndicators.map(pi => (
                                            <div key={`pi-${pi.id}`} className="flex flex-center">
                                                <i className="fa fa-check text-success mr10" />
                                                <span className="flex-grow text-sm">{pi.statement}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
        </Modal>
    );
};

export default CompetencyDetails;
